import React from "react";
import { Divider } from "@mui/material";

export default function SearchSubtitle({ children, title }) {
    return (
        <>
            <h1>{title}</h1>
            <Divider className="mb-5" />
            {children}
        </>
    );
}
